<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!-- <div class="d-flex justify-content-between mb-3">
                            <h5 class="ml-1 mt-2">Regulation Versions</h5>
                            <b-button @click="handleModal('createRegulationModal')" variant="primary" type="button" class="btn btn-primary">
                                <i class="mdi mdi-plus mr-1"> </i> Create Regulation
                            </b-button>
                        </div> -->
                        <LegislationTable @handleModal="handleModal" />
                    </div>
                </div>
            </div>
        </div>
        <CreateRegulationModal v-if="showModal_createRegulationModal" />

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <ChecksTable @handleModal="handleModal" />
                    </div>
                </div>
            </div>
        </div>
        <CreateCheckModal v-if="showModal_createCheckModal" />

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <OptionsTable @handleModal="handleModal" />
                    </div>
                </div>
            </div>
        </div>
        <CreateOptionModal v-if="showModal_createOptionsModal" />
    </div>
</template>

<script>
import LegislationTable from "./tables/legislationTable.vue";
import ChecksTable from "./tables/checksTable.vue";
import OptionsTable from "./tables/optionsTable.vue";

import CreateRegulationModal from "./modals/createRegulationModal.vue";
import CreateCheckModal from "./modals/createCheckModal.vue";
import CreateOptionModal from "./modals/createOptionModal.vue";

export default {
    components: { LegislationTable, ChecksTable, OptionsTable, CreateRegulationModal, CreateCheckModal, CreateOptionModal },
    data: () => ({
        showModal_createRegulationModal: false,
        showModal_createCheckModal: false,
        showModal_createOptionsModal: false,
    }),
    methods: {
        setModalFlag(modelName, flag) {
            // //eslint-disable-next-line
            // console.log("SET MODAL FLAG", modelName, flag);
            if (modelName == "createRegulationModal") return (this.showModal_createRegulationModal = flag);

            if (modelName == "createCheckModal") return (this.showModal_createCheckModal = flag);

            if (modelName == "createOptionModal") return (this.showModal_createOptionsModal = flag);
        },

        //this method refreshes datatables, jsut add the desired datables name as a OR condition
        // refreshDataTable(tableName) {
        //     if (tableName == "certificateListModal" || tableName == "certificateMatchListModal") {
        //         setTimeout(() => {
        //             this.$nextTick(() => {
        //                 window.webix.$$(tableName + "Table").refresh();
        //             });
        //         }, 50);
        //     }
        // },

        // this method handles the displaying of modals
        handleModal(modalName) {
            //eslint-disable-next-line
            console.log("emitted");
            //call the make the modals flag active
            this.setModalFlag(modalName, true);

            setTimeout(() => {
                this.$bvModal.show(`${modalName}`);
                //will refresh the datatable due to DOM render issues
                // this.refreshDataTable(modalName);

                this.$root.$once("bv::modal::hidden", (event) => {
                    if (event.type == "hidden" && event.componentId == `${modalName}`) {
                        this.setModalFlag(modalName, false);
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
